<template lang="pug">
  .dialog-container(v-if="show", @touchmove.prevent)
    .dialog-info
      .dialog-block
        img(src="https://m.hellobike.com/resource/gallery/61/TwKjlWmz_Frame%201.png?x-oss-process=image/quality,q_80")
        .dialog-left-img
          img(src="https://m.hellobike.com/resource/gallery/61/PrnHjTB-_Group%201707482315.png?x-oss-process=image/quality,q_80")
      .dialog-sign(@click="gourl") 去看看
      .dialog-close(@click="closeModal")
        img(src="https://m.hellobike.com/resource/gallery/61/x3maDFT8bq.png?x-oss-process=image/quality,q_80")
    .shadow
    </template>
<script>

import { Native, env } from '@hb/hbridge';

export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    couponInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      env,
    };
  },
  watch: {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false);
    },
    gourl() {
      if (env.isAlipayBrowser || env.isAliMP) {
        Native.callNative({
          method: 'goOperationUrlV2',
          params: this.couponInfo.jumpUrl,
        });
      } else {
        // Native.openThirdWeb({ url: item.bonusEntity.payedImageUrl });
        window.location.href = this.couponInfo.jumpUrl;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-container {
  .dialog-info {
    position: fixed;
    left: 50%;
    top: 0rem;
    transform: translate(-50%, 2.55rem);
    z-index: 330;

    .dialog-block {
      width: 3.51rem;
      height: 1.97rem;
      position: relative;

      img {
        width: 3.51rem;
        height: 1.97rem;
      }

      .dialog-left-img {
        width: 0.13rem;
        height: 2.76rem;
        margin-top: 0.13rem;
        margin-left: 0.12rem;

        img {
          width: 0.13rem;
          height: 2.76rem;
        }
      }
    }

    .dialog-sign {
      width: 0.99rem;
      height: 0.36rem;
      background: linear-gradient(286.07deg, #FFC985 9.44%, #FFEFB0 88.82%);
      color: #7D3B2A;
      margin: 0.38rem auto 0 auto;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      font-size: 0.14rem;
      line-height: 0.36rem;
      text-align: center;
      border-radius: 0.3rem;
    }

    .dialog-close {
      margin-top: 0.4rem;
      display: flex;
      justify-content: center;

      img {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 300;
  }
}
</style>
